import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsComp from "../../component/servicescomponent/ContactUsComp";
import { useForm } from "react-hook-form";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uspstreamsima from "../../assets/uspsiimacolor.png";

export default function UspSimacolorFluids() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Print Technology",
      data: "Continuous Ink Jet",
    },
    {
      title: "Print Speed",
      data: "Up to 1,000 feet/minute (305m/min) 7x5 font matrix",
    },
    {
      title: "Font Matrix Configurations",
      data: "5x5, 7x5, 9x7, 12x12, 16x16, 24x24, 32x32",
    },
    {
      title: "Communication Outputs",
      data: "Alarm light(3-color), print ready, warning",
    },
    {
      title: "Cabinet Construction",
      data: "Stainless street cabinet",
    },
    {
      title: "Inks",
      data: "Comprehensive range of links for a variety of applications and industry requirements including MEK, Acetone, and Ethanol-base; colors and soft pigment formulations available;",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Nozzle Size",
      data: "70µm nozzle standard, 60µm nozzle optional",
    },
    {
      title: "Max Print Lines",
      data: "4 lines of 7x5 matrix font or 5 lines of 5x5 matrix font",
    },
    {
      title: "Character Height",
      data: "0.07” - 0.59” (1.8mm - 15mm); up to 32 dot high font with single line of text",
    },
    {
      title: "Software Features",
      data: "Counter, lot counter, shift code, time and date, expiration date",
    },
    {
      title: "Printhead Dimensions",
      data: "9.25” (23.5cm) long, 1.5” (3.8cm) in diameter",
    },
    {
      title: "Touch Screen/Display",
      data: "Revolutionary wi-fi tablet HMI, printer may run with/without tablet; one table may be used to communicate with multiple printers or other Ink printing systems using Orion software platform",
    },
  ];
  const foodAndBeverage1 = [
    {
      productImg: Images?.industry9,
      label: "Simacolor for IMAJE®",
    },
    { productImg: Images?.industry10, label: "Simacolor for linx®" },
    { productImg: Images?.industry11, label: "Simacolor for videojet®" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 },
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 },
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };
  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP SIMACOLOR FLUIDS"
        printerImg={Images?.uspstream14}
        pdfFile={FilePdf?.SIMACOLOR_fluids}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            USP SIMACOLOR FLUIDS
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            Trust the World-class SIMACOLOR range of industrial inkjet fluids to
            put an end to all production line hiccups and headaches, once and
            for all. Manufactured by the leading global German brand, SIMACO,
            these fluids work ideally in reputed inkjet printers in the
            industry.
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <div className="printerDetailsVideo" ref={youtubeContainerRef}>
          {/* <div className="printerYoutubeLink">
            <iframe
              // className={`youtubeVideo `}
              className={`youtubeVideo ${
                youtubeVideoVisible ? "animated" : ""
              }`}
              width="300"
              height="250"
              src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              style={{ borderRadius: "6px" }}
            ></iframe>
          </div> */}
          <div>
            <div
              className={`printerBrochure ${
                youtubeVideoVisible ? "animated" : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={handleDivClick}
            >
              <div>
                <div className="productImageContainer">
                  <img className="w-[100%]" src={uspstreamsima} alt="" />
                </div>
                {/* Buttons */}
                <div className="brochureImageButtons">
                  <button className="downloadBrochureBtn">
                    Download Brochure
                  </button>
                </div>
                <a
                  href={FilePdf?.SIMACOLOR_fluids}
                  download="Usp SIMACOLOR_FLUID"
                  ref={downloadLinkRef}
                  style={{ display: "none" }}
                >
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <div className="printerPageLeadingAdvantagesContainer">
          <img src={Images?.industry12} alt="" />
        </div>

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
